import { render } from "./ConInsContainerVue.vue?vue&type=template&id=25ad9ae4"
import script from "./ConInsContainerVue.vue?vue&type=script&lang=js"
export * from "./ConInsContainerVue.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LCE\\Documents\\code\\front-end LCE\\centre-sante-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__